import APP from "app";

const getOtpPayload = userData => {
    const { userName } = userData;
    let paylaodVal = {
        key: userName,
        requestId: APP.Utils.getUniqueId(),
        type: 'FORGOT_PASSWORD',
        smsreq: true,
        emailreq: true,
    };
    if (userData.role) {
        return { ...paylaodVal, role: userData.role }
    }
    return paylaodVal
};

export default getOtpPayload;
